/** Timestamp relatif compact — "il y a 3j" / "3d ago" selon la langue. */
export const getTimeAgo = (date: Date | string, lang = 'fr'): string => {
  const target = typeof date === 'string' ? new Date(date) : date;
  const seconds = Math.max(0, Math.floor((Date.now() - target.getTime()) / 1000));
  const en = lang.startsWith('en');

  const wrap = (value: number, unit: string) => (en ? `${value}${unit} ago` : `il y a ${value}${unit}`);

  if (seconds < 60) return wrap(seconds, 's');
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return wrap(minutes, 'm');
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return wrap(hours, 'h');
  const days = Math.floor(hours / 24);
  return wrap(days, en ? 'd' : 'j');
};
